import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const inputCls =
  "w-full bg-[#FAF7F2] border border-[#4A3F35]/15 rounded-sm px-5 py-4 text-sm text-[#4A3F35] placeholder:text-[#8A7D71]/60 outline-none focus:border-[#C6A769] transition-colors duration-300";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received — we'll be in touch soon, beautiful.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again or email us directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="contact-page" className="pt-20 min-h-screen bg-[#F8F5F0]">
      <section className="max-w-xl mx-auto px-6 py-24 sm:py-32">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C6A769] mb-6 text-center">Get In Touch</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#4A3F35] mb-8 text-center">
          Contact
        </h1>
        <div className="w-16 h-px bg-[#C6A769] mx-auto mb-10" />
        <p className="text-base text-[#4A3F35]/70 leading-relaxed mb-12 text-center">
          Questions about your order, a product, or collaborations?
          Leave us a note — we'd love to hear from you.
        </p>

        <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
          <input
            type="text"
            required
            value={form.name}
            onChange={set("name")}
            placeholder="Your name"
            data-testid="contact-name-input"
            className={inputCls}
          />
          <input
            type="email"
            required
            value={form.email}
            onChange={set("email")}
            placeholder="Your email"
            data-testid="contact-email-input-field"
            className={inputCls}
          />
          <textarea
            required
            rows={6}
            value={form.message}
            onChange={set("message")}
            placeholder="Your message"
            data-testid="contact-message-input"
            className={`${inputCls} resize-none`}
          />
          <button
            type="submit"
            disabled={sending}
            data-testid="contact-submit-button"
            className="w-full bg-[#C6A769] text-[#4A3F35] py-4 rounded-sm text-sm font-medium uppercase tracking-[0.18em] transition-all duration-300 hover:bg-[#B08F50] disabled:opacity-60 inline-flex items-center justify-center gap-2"
          >
            {sending ? (
              <><Loader2 className="w-4 h-4 animate-spin" /> Sending…</>
            ) : (
              "Send Message"
            )}
          </button>
        </form>

        <p className="text-sm text-[#8A7D71] text-center mt-10">
          Prefer email?{" "}
          <a
            href="mailto:sales@benzthebrand.com"
            data-testid="contact-email-link"
            className="inline-flex items-center gap-1.5 text-[#C6A769] hover:text-[#4A3F35] transition-colors duration-300"
          >
            <Mail className="w-4 h-4" strokeWidth={1.5} /> sales@benzthebrand.com
          </a>
        </p>
      </section>
    </div>
  );
}
